// extracted by mini-css-extract-plugin
export default {"container":"promotion-campaigns_container__cDQ67","queryContainer":"promotion-campaigns_queryContainer__FN0df","queryButton":"promotion-campaigns_queryButton__PgZpn"};